import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Card, Tag, Input, Button, Select, Modal, message } from "antd";
import {
  req_list_pim_flexible_log_staff,
  req_edit_pim_flexible_log_staff,
  req_del_pim_flexible_log_staff,
  req_edit_pim_swap_log
} from "../../api";
import { getDateYYYYMM } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import FlexibleLogStaffAddModal from "./flexible-log-staff-add-modal";
import FlexibleLogStaffImportModal from "./flexible-log-staff-import-modal";

class FlexibleLogStaff extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: window.innerWidth,
    nowYearMonth: getDateYYYYMM(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    searchField: "None",
    searchValue: "",
    data: [],
    item: {},
    isShowAddModal: false,
    isUploadModal: false,
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_item_list();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { nowYearMonth, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_pim_flexible_log_staff(
      userLevel,
      userCode,
      nowYearMonth,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_pim_flexible_log_staff(item, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      message.error(result.message);
    }
  };

  api_modify_swap_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_pim_swap_log(item, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      message.error(result.message);
    }
  };

  api_detete_item = async (item) => {
    const { Uid } = item;
    const { token, userCode } = this.props.user;

    const result = await req_del_pim_flexible_log_staff(Uid, userCode, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      message.error(result.message);
    }
  };

  // 樣式設定 //////////////////////////////////////////////
  statusApplyDescription = (Status) => {
    switch (Status) {
      case "APPLY":
        return "申請中";
      case "AY":
        return "單位二級主管通過";
      case "BY":
        return "單位一級主管通過";
      case "CY":
        return "人事室承辦人通過";
      case "DY":
        return "人事室承辦主管通過";
      case "EY":
        return "人事室主任通過";
      case "ALLAGREE":
        return "申請已通過";
      case "AN":
        return "單位二級主管未通過";
      case "BN":
        return "單位一級主管未通過";
      case "CN":
        return "人事室承辦人未通過";
      case "DN":
        return "人事室承辦主管未通過";
      case "EN":
        return "人事室主任未通過";
      case "ZN":
        return "註銷";
      default:
        return "申請未通過";
    }
  };

  statusWorkDescription = (Status) => {
    switch (Status) {
      case "PASS":
        return "停班";
      case "WORK":
        return "上班";
      default:
        return "待定";
    }
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "REASON":
        switch (param) {
          case "工作日":
            return "blue";
          case "休息日":
            return "green";
          case "例假日":
          case "國定假日":
          case "停班停課":
            return "red";
          case "休假日":
            return "gold";
          case "平假日調換":
            return "purple";
          case "工作日調移":
            return "Tan";
          case "單日作息調整":
            return "#34495e";
          default:
            return "default";
        }
      case "TYPE":
        switch (param) {
          case "補簽到退申請":
            return "blue";
          case "工作日加班申請":
            return "orange";
          case "休息日加班申請":
            return "red";
          case "平假日調換申請":
            return "purple";
          case "工作日調移申請":
            return "Tan";
          case "單日作息調整申請":
            return "#34495e";
          case "人事室作息設定":
            return "green";
          default:
            return "default";
        }
      case "WEEK":
        switch (param) {
          case "週一":
          case "週二":
          case "週三":
          case "週四":
          case "週五":
            return "blue";
          case "週六":
            return "green";
          case "週日":
            return "red";
          default:
            return "default";
        }
      case "STATUS_WORK":
        switch (param) {
          case "PASS":
            return "red";
          case "WORK":
            return "blue";
          default:
            return "blue";
        }
      case "STATUS_APPLY":
        switch (param) {
          case "APPLY":
            return "blue";
          case "AY":
            return "blue";
          case "BY":
            return "blue";
          case "CY":
            return "blue";
          case "DY":
            return "blue";
          case "EY":
            return "blue";
          case "ALLAGREE":
            return "green";
          case "AN":
            return "red";
          case "BN":
            return "red";
          case "CN":
            return "red";
          case "DN":
            return "red";
          case "EN":
            return "red";
          case "ZN":
            return "red";
          default:
            return "blue";
        }
      case "STATUS_CONFIRM":
        switch (param) {
          case "NO":
            return "red";
          case "YES":
            return "green";
          default:
            return "default";
        }
      default:
        return "blue";
    }
  }

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_item_list();
  };

  handle_btn_cancel = (item) => {
    const { Uid } = item;
    Modal.confirm({
      title: `您確定註銷此筆資料嗎?`,
      onOk: () => {
        if (item.ApplyType === "平假日調換申請") {
          console.log(item)
          const row_swap = {
            Uid: Uid,
            ApplyStatus: "ZN",
            condition: "BASE",
          };
          this.api_modify_swap_item(row_swap);
        } else if (item.ApplyType === "工作日調移申請") {
          const row_shift = {
            Uid: Uid,
            ApplyStatus: "ZN",
            condition: "BASE",
          };
          this.api_modify_swap_item(row_shift);       
        }
          else {
          const row_flix = {
            Uid: Uid,
            ApplyStatus: "ZN",
            condition: "BASE",
          };
          this.api_modify_item(row_flix);
        }
      },
    });
  };

  handle_btn_delete = (item) => {
    const { Uid } = item;
    const row = {
      Uid: Uid,
      ApplyStatus: "ZN",
      condition: "BASE",
    };
    Modal.confirm({
      title: `您確定刪除此筆資料嗎，將無法回復?`,
      onOk: () => {
        this.api_detete_item(row);
      },
    });
  };

  handle_btn_add_single = () => {
    this.setState({ isShowAddModal: true });
  };
  handle_btn_add_multiple = () => {
    this.setState({ isUploadModal: true });
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "操作",
        width: "80px",
        align: "center",
        fixed: "true",
        render: (item) => {
          const { ApplyStatus, RecordCreatorCode } = item;
          return (
            <>
              {" "}
              {RecordCreatorCode === this.props.user.userCode ? (
                <>
                  {" "}
                  <button
                    style={{ marginRight: "5px" }}
                    className={"btn btn-danger btn-sm"}
                    onClick={() => this.handle_btn_delete(item)}
                  >
                    <i className="fas fa-calendar-minus"></i> 刪除
                  </button>
                </>
              ) : (
                ""
              )}
              {ApplyStatus === "ALLAGREE" ? (
                <>
                  <button
                    className={
                      ApplyStatus === "ALLAGREE"
                        ? "btn btn-warning btn-sm"
                        : "btn btn-info btn-sm"
                    }
                    onClick={() => this.handle_btn_cancel(item)}
                  >
                    <i className="fas fa-calendar-times"></i> 註銷
                  </button>
                </>
              ) : ApplyStatus.charAt(1) === "Y" ? (
                <Tag color="red">審核中</Tag>
              ) : ApplyStatus === "APPLY" ? (
                <Tag color="red">審核中</Tag>
              ) : (
                <Tag color="gray">無效</Tag>
              )}
            </>
          );
        },
      },
      {
        title: "彈班分類",
        dataIndex: "ApplyType",
        key: "ApplyType",
        align: "center",
        filters: [
          {
            text: "平假日調換申請",
            value: "平假日調換申請",
          },
          {
            text: "單日作息調整申請",
            value: "單日作息調整申請",
          },
          {
            text: "人事室作息設定",
            value: "人事室作息設定",
          },
        ],
        // specify the condition of filtering result
        // here is that finding the name started with `value`
        onFilter: (value, record) => record.ApplyType.indexOf(value) === 0,
        width: 100,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("TYPE", text)}>{text}</Tag>
          </>
        ),
      },
      {
        title: "審查狀況",
        align: "center",
        width: 100,
        render: (item) => {
          const { ApplyStatus, ApplyType } = item;
          return (
            <>
              {ApplyType === "人事室作息設定" ? (
                <></>
              ) : (
                <Tag
                  color={this.style_switch_color_tag(
                    "STATUS_APPLY",
                    ApplyStatus
                  )}
                >
                  {this.statusApplyDescription(ApplyStatus)}
                </Tag>
              )}
            </>
          );
        },
      },
      {
        title: "職號",
        dataIndex: "StaffCode",
        key: "StaffCode",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "姓名",
        dataIndex: "StaffName",
        key: "StaffName",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "申請作息",
        dataIndex: "FlexibleStatus",
        key: "FlexibleStatus",
        align: "center",
        width: 90,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("STATUS_WORK", text)}>
              {this.statusWorkDescription(text)}
            </Tag>
          </>
        ),
      },
      {
        title: "彈性班表日期",
        align: "center",
        width: 120,
        render: (item) => (
          <span
            style={{
              color: this.style_switch_color_tag("WEEK", item.WeekdayName),
            }}
          >
            {item.FlexibleDate} {item.WeekdayName}
          </span>
        ),
      },
      {
        title: "起始時間",
        dataIndex: "FlexibleClockIn",
        key: "FlexibleClockIn",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "結束時間",
        dataIndex: "FlexibleClockOut",
        key: "FlexibleClockOut",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "原因說明",
        dataIndex: "RecordDescription",
        key: "RecordDescription",
        width: 100,
        render: (text) => <>{text}</>,
      },
    ];
  };

  ///////////////////////////////////////////////////////////
  render() {
    const {
      data,
      loading,
      nowYearMonth,
      searchField,
      searchValue,
      isShowAddModal,
      isUploadModal,
    } = this.state;
    const title = (
      <div>
        <Input
          placeholder="年月"
          style={{ width: 100, margin: "0 5px" }}
          value={nowYearMonth}
          onChange={(event) =>
            this.setState({ nowYearMonth: event.target.value })
          }
        />
        <Select 
          value={searchField}
          style={{ width: 100 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">請選擇</Select.Option>
          <Select.Option value="StaffCode">職號</Select.Option>
          <Select.Option value="StaffName">姓名</Select.Option>
          <Select.Option value="UnitName">部門名稱</Select.Option>
          <Select.Option value="FlexibleDate">彈班日期</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_item_list()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_btn_add_single()}>
          <i className="fas fa-calendar-plus"></i>
          <span style={{ marginLeft: "4px" }}>單筆新增</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_btn_add_multiple()}>
          <i className="fas fa-file-import"></i>
          <span style={{ marginLeft: "4px" }}>多筆匯入</span>
        </Button>{" "}
      </div>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          rowKey="Uid"
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowAddModal}
          width={350}
          onOk={() => {
            this.setState({ isShowAddModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <FlexibleLogStaffAddModal />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isUploadModal}
          width={300}
          onOk={() => {
            this.setState({ isUploadModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isUploadModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <FlexibleLogStaffImportModal
            item={this.props.location.state}
            creator={this.props.user}
          />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(FlexibleLogStaff);
